<template>
    <b-row class="px-1 mx-1">
        <b-col class="col-md-0 col-lg-3 px-0"></b-col>
        <b-col class="col-md-12 col-lg-6 px-0" align="center">
            <div class="p-2">
                <div class="card">
                    <div class="card-body">
                        <b-overlay
                            :show="queryInProgress"
                            spinner-type="grow"
                            rounded="lg"
                            spinner-small
                        ><!-- overlay -->
                            <h3>MDS Statistik</h3>
                            <b-table v-if="statistics" :items="items" />
                            <b-row class="mx-2">
                                <span>ältestes Product (lastSuccessfulMetaDataRequest): <b>{{productLastSuccessfulMetaDataRequest}}</b></span>
                            </b-row>
                            <b-row class="mx-2 my-2">
                                <span>ältester Request Job (doneAt): <b>{{requestJobDoneAt}}</b></span>
                            </b-row>
                        </b-overlay>
                        <b-row class="my-4">
                            <b-col class="col-4"></b-col>
                            <b-col class="col-4" align="center"><h2 v-if="queryInProgress">Lädt...</h2></b-col>
                            <b-col class="col-4"></b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </b-col>
        <b-col class="col-md-0 col-lg-3" px-0></b-col>
    </b-row>
</template>
<script>
export default
{
    data() { return {
        queryInProgress: true,
        statistics: null,
        items: null,
        productLastSuccessfulMetaDataRequest: "",
        requestJobDoneAt: ""
    }},
    mounted()
    {
        Promise.all([
            axios.get('/mds/request_job/statistics'),
            axios.get('/mds/product/crusty/1'),
            axios.post('/mds/request_job/crusty', {amount: 1, done_at_limit: 0 }),
            new Promise( r => setTimeout(r, 750))
        ]).then( ([_stats, _crustyProduct, _crustyRequestJob]) => {
          this.queryInProgress = false;

          if (_crustyRequestJob.data.length == 0) {
            this.$bvToast.toast("Es wurden keine Request-Jobs gefunden.", {
              title: "ERROR MDS Statistics",
              autoHideDelay: 32000,
              appendToast: false,
              variant: 'warning'
            });
          } else {
            this.requestJobDoneAt = moment(_crustyRequestJob.data[0].doneAt ? _crustyRequestJob.data[0].doneAt : _crustyRequestJob.data[0].createdAt, 'YYYY-MM-DDTHH:mm:ss....Z').format('DD.MM.YYYY HH:mm');
          }
          this.productLastSuccessfulMetaDataRequest = moment(_crustyProduct.data[0].lastSuccessfulMetaDataRequest, 'YYYY-MM-DDTHH:mm:ss....Z').format('DD.MM.YYYY HH:mm');
          this.statistics = _stats.data;
          this.items = [
              { Beschreibung: 'erfolgreich abgeschlossene Request-Jobs',             state: 'finished',         total: this.statistics.total.finished, daily: this.statistics.dailyDone.finished },
              { Beschreibung: 'ausstehende Request-Jobs',                            state: 'created',          total: this.statistics.total.created, daily: this.statistics.daily.created },
              { Beschreibung: 'ausstehende Request-Job-Anfragen',                    state: 'pending',          total: this.statistics.total.pending, daily: this.statistics.daily.pending },
              { Beschreibung: 'Request-Jobs mit uneindeutiger ASIN',                 state: 'actionRequired',   total: this.statistics.total.actionRequired, daily: this.statistics.daily.actionRequired },
              { Beschreibung: 'Fehler',                                              state: 'error',            total: this.statistics.total.error, daily: this.statistics.daily.error },
              { Beschreibung: 'manuell gesetzte ASIN',                               state: 'manualAsinSet',    total: this.statistics.total.manualAsinSet, daily: this.statistics.daily.manualAsinSet },
              { Beschreibung: 'Request-Jobs mit abgeschlossenen Metadatenanfragen	', state: 'requestsFinished', total: this.statistics.total.requestsFinished, daily: this.statistics.daily.requestsFinished }
          ];
        }).catch( error => {
            this.queryInProgress = false;
            this.$bvToast.toast( "Etwas ist bei der Abfrage der Daten schief gelaufen. Bitte laden Sie die Seite neu.", {
                title: "ERROR MDS Statistics",
                autoHideDelay: 32000,
                appendToast: false,
                variant: 'danger'
            });
            console.error(error);
        });
    }
}
</script>
